export class  RejectionRequest {
    
    rejectionId: number;
   
    
}